/** Максимальное количество версий в release-notes.json */
export const MAX_RELEASE_VERSIONS = 20;

/** Ключ localStorage для просмотренных фич (badge'ей) */
export const SEEN_FEATURES_KEY = 'roll1:seen-features';

/** Ключ localStorage для последней просмотренной версии */
export const LAST_SEEN_VERSION_KEY = 'roll1:last-seen-version';

/** Время автоскрытия splash-карточки (мс) */
export const SPLASH_AUTO_DISMISS_MS = 10_000;

/** Текущая версия приложения из env */
export const APP_VERSION = import.meta.env.VITE_APP_VERSION as string | undefined;
